module.exports = __webpack_public_path__ + "static/img/manual-4.ea46c24.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-4.png
// module id = lF1Z
// module chunks = 4